App.module('MessageCenterApp.Entities', function(Entities, App, Backbone, Marionette, $, _){
    'use strict';

    Entities.MessageItem = Backbone.Model.extend({
        defaults: {
            dateString: null,
            deleted: false,
            content: ''
        },
        initialize: function() {
            this.setStringDate();
        },
        setStringDate: function() {
            var date = moment(new Date(formatDate(this.get('date')))),
                diffDays = moment().diff(date, 'days');

            if(diffDays === 0) {
                this.set('dateString', 'Today');
            } else if(diffDays === 1) {
                this.set('dateString', 'Yesterday');
            } else {
                this.set('dateString', date.format('MMM DD, YYYY'));
            }
        }
    });

    Entities.MessagesCollection = Backbone.Collection.extend({
        model: Entities.MessageItem,
        withoutDeleted : function(){
            return _(this.filter(function(data) {
                return !data.get("deleted");
            }));
        }
    });
});